import { AdvicesEntity } from '../store/types/prescription';
import { SEND_TO_SLACK } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

type RequestBody = {
    key: string;
    payload: any;
};

type RequestResponse = {
    success: boolean;
};

export default ({ key, payload }: { key: string; payload: any }): Promise<RequestResponse> => {
    const request: RequestBody = {
        key,
        payload,
    };
    return fetchWithRefresh(SEND_TO_SLACK, {
        method: 'POST',
        body: JSON.stringify(request),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => {
        return res.json();
    });
};
